import '../Assets/Styles/general.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate,useLocation,Route,Routes,Navigate} from 'react-router-dom';

// Components Loading
import { Button } from 'primereact/button'; 
import { ScrollTop } from 'primereact/scrolltop';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ProgressBar } from 'primereact/progressbar';

import jwtDecode from 'jwt-decode';

// External Libs loading
import routes from "../routes.js";
import * as config from '../Config/api.js';

// Import template images
import iconLoadingGlobal from '../Assets/Images/iconLoadingGlobal.svg';   

import BackToTopButton from '../Components/BackToTopButton'; // Importe o componente

// Load Actions
import * as AppActions from '../Store/Actions/App'

// Load Components
import FooterView from '../Components/Layout/Footer';
import AlertView from '../Components/AlertModal';
import ProtectedRoute from '../Components/ProtectedRoute'; // ajuste o caminho

const Desktop = (props) => {

	// Set var from props
	const {
		setDialog,
		dialog,
		loginStatus,
		userProfile,
		setUserProfile,
		setLoginStatus,
		retrieveAndSetUserInfo,
		globalInnerLoading,
		globalInnerMessage,
	} = props;
	
// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertAction, setAlertAction] = React.useState(""); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 	

// Global loading for User Data Loading If logged and not approved (only for under review or repproved status)
var logged = localStorage.getItem("@estacaodoolho/logged");
const [globalLoading, setGlobalLoading] = React.useState(logged == "1" ? true : false); 	

// Set location
const location = useLocation();
const { hash, pathname, search } = location;
	
// set Use of history for PUSH 
var navigate = useNavigate();	

{/* Get all routes */}
const getRoutes = (routes) => {
  return routes.map((prop, key) => {
    const Component = prop.component;

    const element = prop.secured ? (
      <ProtectedRoute>
        <Component />
      </ProtectedRoute>
    ) : (
      <Component />
    );

    return (
      <Route
        exact
        path={prop.path}
        element={element}
        key={key}
      />
    );
  });
};


// Logoff method
const logOut = () => {

	console.log('RODOU LOGOUT |-------------> ');

	// Set logoff flag
	localStorage.setItem("@estacaodoolho/logged",0);
	
	// Remove userData 
	localStorage.removeItem("@estacaodoolho/userData");	

	setLoginStatus(false);
	//navigate("/");
	//localStorage.setItem("@estacaodoolho/logged", "1");
	//setLoginStatus(true);
	//setUserProfile("customer");
	
}	

// Execute when route changes
React.useEffect(() => {

	// Retrieve User Data Obj. 
	var result = localStorage.getItem("@estacaodoolho/userData");
	const userData = (() => { try { return jwtDecode(result); } catch { return {}; } })();

	  // If token dont exist, redirect to onboarding or register
	  if (userData.CompanyPersonUserId) {
		  setLoginStatus(true);
		  return;
	  } else {
		  logOut();
		  return;
	  }
    
  }, [location,navigate]); 


// Execute when mount component
React.useEffect(() => {

	// Retrieve User Data Obj. 
	var result = localStorage.getItem("@estacaodoolho/userData");
	const userData = (() => { try { return jwtDecode(result); } catch { return {}; } })();

	  // If token dont exist, redirect to onboarding or register
	  if (!userData.CompanyPersonUserId) {
		  setLoginStatus(false);
		  logOut();
		  return;
	  }
	  
	// Set Global loading on since its logged
	setGlobalLoading(true);
		
	// Set logged 
	localStorage.setItem("@estacaodoolho/logged", "1");
	setLoginStatus(true);

	/*var props = {
		setGlobalLoading:setGlobalLoading,
		logOut:logOut,
		setLoginStatus:setLoginStatus,
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody
	}
	var data = {
	  loginStatus: loginStatus
	}
	retrieveAndSetUserInfo(data,props);	*/

	setTimeout(() => {
		// Set global loading off
		setGlobalLoading(false);
	}, 2000); // Simulate loading time


	// Runs when UNMOUNT component
	return () => {
				
		
	};

}, []); // end useEffect 


// If globalLoading True, show loading screen
if (globalLoading) {
return(
<div className="wrapper" style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%",height:"100vh",backgroundColor:"#FFFFFF50"}}>

	<div style={{flex:1,display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",width:"30vw"}}>
		<ProgressSpinner />
		<div className="formTitle" style={{marginBottom:"40px"}}>Carregando...</div>

		<div style={{marginBottom:"20px",display:"flex",flexdirection:"row",alignItems:"center",justifyContent:"center"}}>
			<img src={iconLoadingGlobal} clasSName="noSelect" />
		</div>

		<div className="formSubTitle mT10 flex-column justify-center align-items-center" style={{gap:"1rem"}}><strong style={{fontSize:"1.5rem"}}>Estação de Olho</strong>Democratizando o cuidado a saúde ocular</div>		
	</div>

</div>
);	
}

// If globalLoading False, keep going
  return (
  <>
    <div className="wrapper">

		{globalInnerLoading &&
		  <div className="loadingPanel">
				<div style={{flex:1,display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",width:"20vw",textAlign:"center",marginTop:"-5rem"}}>
					{/*<ProgressSpinner />*/}
					<ProgressBar mode="indeterminate" style={{ marginBottom:"1rem",height: '6px',width:"40vw" }}></ProgressBar>
					<div className="formTitle" style={{marginBottom:"15px",marginTop:"25px",fontSize:"2rem",width:"36vw"}}>{globalInnerMessage}</div>
					<small>Não feche essa janela até a conclusão</small>
				</div>
		   </div>           
		}      		

	  {/* Body  */}
      <div className="wrapper__content">        
          <div className="wrapper__content_container home">
		     <Routes>
				{getRoutes(routes)}	
				<Route
					path="*"
					element={<Navigate to="/" replace />}
				/>				
			  </Routes>
          </div>  
      </div>  

	  {/* Fooer Component */}
	  <FooterView />
	  
    </div>

	<AlertView
		alert={alert}
		setAlert={setAlert}
		alertTitle={alertTitle}
		alertBody={alertBody}
		alertAction={alertAction}
		scrollBlock={false}				
	/>

      {/* Componente BackToTopButton */}
      <BackToTopButton />	

	</>	
  );
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  userProfile:store.appReducer.userProfile,
  globalInnerLoading:store.appReducer.globalInnerLoading,
  globalInnerMessage:store.appReducer.globalInnerMessage
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);


export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Desktop);
